import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { Landing } from "./pages/Landing";
import { Login } from "./pages/Login";
import { ArenaLogin } from "./pages/ArenaLogin";
import { XODemoChat } from "./pages/XODemoChat";
import { TenantManagement } from "./pages/TenantManagement";
import { Tournaments } from "./pages/Tournaments";
import { Analytics } from "./pages/Analytics";
import { Support } from "./pages/Support";
import { ArenaPlayerChat } from "./pages/ArenaPlayerChat";
import { ClientDashboard } from "./pages/ClientDashboard";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            {/* Landing Page */}
            <Route path="/" element={<Landing />} />
            
            {/* XO Admin Login */}
            <Route path="/login" element={<Login />} />
            
            {/* Arena Branded Client Login */}
            <Route path="/arena/login" element={<ArenaLogin />} />
            
            {/* XO Demo Chat - opens in new tab */}
            <Route path="/demo/chat" element={<XODemoChat />} />
            
            {/* XO Admin Dashboard - Client Management */}
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <TenantManagement />
              </ProtectedRoute>
            } />
            <Route path="/clients" element={
              <ProtectedRoute>
                <TenantManagement />
              </ProtectedRoute>
            } />
            <Route path="/tournaments" element={
              <ProtectedRoute>
                <Tournaments />
              </ProtectedRoute>
            } />
            <Route path="/analytics" element={
              <ProtectedRoute adminOnly>
                <Analytics />
              </ProtectedRoute>
            } />
            <Route path="/support" element={
              <ProtectedRoute>
                <Support />
              </ProtectedRoute>
            } />
            
            {/* Client Dashboard - Arena */}
            <Route path="/client/dashboard" element={<ClientDashboard />} />
            
            {/* Customer-facing Chat - What players see */}
            <Route path="/arena/chat" element={<ArenaPlayerChat />} />
            <Route path="/chat" element={<ArenaPlayerChat />} />
            
            {/* Catch all */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </AuthProvider>
  );
}

export default App;
